import {Component, Inject, Input, OnChanges, OnInit, OnDestroy, SimpleChanges, ElementRef, HostListener} from '@angular/core';
import {OrganisationService} from "../../services/organisation/organisation.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import * as Cookies from "js-cookie";
import {ConstantsService} from "../../services/constants/constants.service";
import {AuthService} from "../../services/auth/auth.service";
import {SwitchOrganisationModalComponent} from "../switch-organisation-modal/switch-organisation-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import {environment} from "../../../environments/environment";
import {PermissionsService} from "../../services/permissions/permissions.service";

import * as uuidv1 from "uuid/v1";
import {PlanService} from 'src/app/services/plan-status/plan-status.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LANG_OPTIONS_WITH_OUT_TRANSLATION} from "../../lang.constants";
import {ProfileService} from '../../services/profile/profile.service';
import {IdService} from 'src/app/services/id/id.service';
import {TrustMarketplaceStatusService} from "../../services/trust-marketplace-status/trust-marketplace-status.service";
import {BillingService} from "../../services/billing/billing.service";
import {lastValueFrom, interval, switchMap, takeWhile, takeUntil, timer, Subscription} from "rxjs";
import {RegionService} from '../../services/region/region.service';
import {PeopleService} from "../../services/people/people.service";
import {TalentPoolReportModalComponent} from "../talent-pool-report-modal/talent-pool-report-modal.component";
import {GenerateReportComponent} from "../generate-report/generate-report.component";
import {AiSettingsService, AiSettingsResponse} from '../../services/ai-settings/ai-settings.service';
import {ApiService} from "../../services/api/api.service";
import {map, catchError} from "rxjs/operators";
import {G2Service} from "../../services/g2/g2.service";
import {G2FormsModalComponent} from "../g2-forms-modal/g2-forms-modal.component";
import {of} from "rxjs";

declare const Chargebee: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.pug',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() status: any
  @Input() billingFlow: any
  availableOrgs: any = [];
  selectedOrg: any;
  private bsModalRef: any;
  userRole: any;
  SfdcId: any = ' ';
  contactLink = ConstantsService.ACCOUNT_MANAGER_CONTACT
  mergedContactLink = ''
  bannerMessage: any = '';
  defaultLogo = ConstantsService.DEFAULT_LOGO;
  languageLocal = Cookies.get(ConstantsService.XREF_LOCALE)?.toUpperCase();
  futureMessage = $localize`Almost there! Your subscription will be activated on `
  inactiveMessage = $localize`Unfortunately, your subscription is pending activation. `
  pastMessage = $localize`Unfortunately, your subscription expired on `
  recruiterLinkAvailable = false;
  showXrefAccountManagerLink = false;
  showRenewSubLink = false;
  engageUrl: string = environment.ENGAGE_URL;
  trustUrl: string = environment.TRUST_MARKETPLACE_URL;
  trustInfoUrl: string = environment.TRUST_MARKETPLACE_INFO_URL;
  userdetails = {};
  defaultRegion = 'au';

  loading = true;
  loadingReportDropdown = true;
  profileData: any = {};

  // passing Values to KababMenuComp
  defaultSelectOption: string = Cookies.get(ConstantsService.XREF_LOCALE)?.toLocaleLowerCase() || '';
  languagesOptionKey: { key: string, value: string }[] = []
  openLeftSide = true
  nonToggledImgUrl = "https://assets.xref.com/omni/shared/globe_black.svg"
  toggledImgUrl = "https://assets.xref.com/omni/shared/globe_green.svg"
  dropDownFor = 'language'
  trustStatus = 0;
  tmpAdminStatus: number | undefined = 1;
  turnOver: any = {}
  canSwitchOrg = false;
  viewOrgSettings = false;
  viewSubscriptionDetails = false;
  setPersonalSettings = false;
  canUseRecruiterLink = false;
  canUseEngageLink = false;
  canUseTrustLink = false;
  canViewContactAccountManagerLink = false;
  canViewOrGenerateTalentPoolExportReports = false;
  canGenerateReportPermissions = false;
  referenceTooltipText = $localize`Contact your Reference administrator to gain access to this feature.`;
  trustTooltipText = $localize`Contact your Background check administrator to gain access to this feature.`;
  chatbotState = false;
  reportDropdownState = false;
  disableGenerateReport = false;
  tooltipGenerateReport = $localize`The maximum number of reports has been reached. Please try again later.`;
  allReports: any = [];
  DATA_3300_XREF_AI_CHATBOT = false;
  aiSupportEnabled = false;
  XREF_CHATBOT_URL: SafeResourceUrl = '';
  ENT_9460_COMBINED_API_CALLS = false;
  billingUser = false;
  ENT_9384_V2_NAV_BANNER_IMPL = false;
  ent_9105 = false;
  ENT_10363_PULSE_RELAUNCH = false;
  private chargebeeInstance: any;
  private aiSettingsSubscription?: Subscription;
  private pollingSubscription: any;
  private modalCloseEventSubscription?: Subscription;

  // Add new properties for auth token monitoring
  private lastAuthToken: string | null = null;
  private ent_9105_penetration_test_2025: boolean = false;

  // Store G2 token data in memory (not localStorage/cookies)
  private cachedG2TokenData: { state: string; review_exists: boolean } | null = null;

  // Store references to event listeners for proper cleanup
  private onStorageListener: (event: StorageEvent) => void = () => {};
  private onMessageListener: (event: MessageEvent) => void = () => {};

  readonly timeInterval = 5000; // it means 5 seconds, because the unit of time is milliseconds here
  readonly stopPollingTime = 180000; // it will stop the polling after 180 seconds or 3 minutes

  constructor(
    public organisationService: OrganisationService,
    private sanitizer: DomSanitizer,
    private alertList: AlertBannerService,
    @Inject(AuthService) private auth: AuthService,
    private id: IdService,
    private modalService: BsModalService,
    private permissions: PermissionsService,
    private planservice: PlanService,
    private router: Router,
    private profile: ProfileService,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
    private activatedRoute: ActivatedRoute,
    private billingService: BillingService,
    private regionService: RegionService,
    public peopleService: PeopleService,
    private eRef: ElementRef,
    private aiSettingsService: AiSettingsService,
    private apiService: ApiService,
    private g2Service: G2Service,
  ) {
  }

  ngOnInit(): void {
    this.setLanguageDropDown()
    this.ENT_9384_V2_NAV_BANNER_IMPL = this.permissions.isFeatureActivated('ENT_9384_V2_NAV_BANNER_IMPL');
    this.ENT_9460_COMBINED_API_CALLS = this.permissions.isFeatureActivated('ent-9460-combined-api-calls');
    this.ent_9105 = this.permissions.isGlobalFeatureActivated('ENT-9105-PENETRATION-TEST-2025');
    this.ENT_10363_PULSE_RELAUNCH = this.permissions.isFeatureActivated('ent-10363-pulse-relaunch');
    this.canSwitchOrg = this.permissions.hasPermission('can_use_switch_organisation')
    this.viewOrgSettings = this.permissions.hasPermission('can_view_organisation_settings')
    this.viewSubscriptionDetails = this.permissions.hasPermission('can_use_subscription_details')
    this.setPersonalSettings = this.permissions.hasPermission('can_set_personal_settings')
    this.canUseRecruiterLink = this.permissions.hasPermission('can_use_link_to_recruiter')
    this.canUseEngageLink = this.permissions.hasPermission('can_use_link_to_engage')
    this.canUseTrustLink = this.permissions.hasPermission('can_use_link_to_trust')
    this.canViewContactAccountManagerLink = this.permissions.hasPermission(
      'can_access_subscription_contact_account_manager_link')
    this.canViewOrGenerateTalentPoolExportReports = this.permissions.hasPermission(
      'can_view_or_generate_talent_pool_export_reports')
    this.canGenerateReportPermissions = this.permissions.hasPermission(
      'can_generate_report')
    // set AI Assistant values
    this.DATA_3300_XREF_AI_CHATBOT = this.permissions.isFeatureActivated(
      'DATA-3300-XREF-AI-CHATBOT'
    );

    if (this.DATA_3300_XREF_AI_CHATBOT) {
      let region = this.regionService.getRegion() ?? 'au';
      this.XREF_CHATBOT_URL = this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.XREF_CHAT_URL[region]
      );

      // Subscribe to AI settings changes to check if support is enabled
      this.aiSettingsSubscription = this.aiSettingsService.aiSettings$.subscribe({
        next: (settings: AiSettingsResponse | null) => {
          this.aiSupportEnabled = settings?.config?.support ?? false;
        },
        error: (error) => {
          console.error('Error loading AI settings for header:', error);
          this.aiSupportEnabled = false;
        }
      });

      // Initial load of AI settings
      this.aiSettingsService.getAiSettings().subscribe();

      // Initialize the penetration test feature flag
      this.ent_9105_penetration_test_2025 = this.permissions.isGlobalFeatureActivated('ENT-9105-PENETRATION-TEST-2025');

      // Setup auth token monitoring if feature flag is enabled
      if (this.ent_9105_penetration_test_2025) {
        this.setupAuthTokenMonitoring();
      }
    }

    if (this.billingFlow) {
      this.organisationService.getOrganisation().subscribe(res => {
          this.selectedOrg = res;
        },
        (err: any) => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
    } else {
      if(!this.ENT_9460_COMBINED_API_CALLS){
        this.callPlan();
      }
      // @ts-ignore
      this.organisationService.getOrganisation().subscribe(res => {
          this.selectedOrg = res;
          this.billingUser = this.selectedOrg?.billing_user;
          if (this.billingUser) {
            let cbSite = this.selectedOrg.billing_timezone;
            if (environment.env === 'dev') {
              cbSite += '-test';
            } else if (environment.env === 'sandbox') {
              cbSite += '-sbx-test';
            }
            this.chargebeeInstance = Chargebee.init({
              site: cbSite,
            });
          }
          this.organisationService.setOrganisationBrandName(res.brand_name)
          this.recruiterLinkAvailable = res.xrp_enabled;
        },
        (err: any) => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
      this.getProfileDetails();
      this.getTMPStatus();

      this.contactLink = ConstantsService.ACCOUNT_MANAGER_CONTACT;
      this.watchSwitchOrg();
    }
  }

  watchSwitchOrg() {
    this.organisationService.getSwitchOrg().subscribe(res => {
      if (res) {
        this.organisationService.setSwitchOrg(false);
        let newOrgUid = this.activatedRoute.snapshot?.queryParams['org_uid'];
        let region = this.activatedRoute.snapshot?.queryParams['region'];
        if (newOrgUid && region) {
          this.switchOrg({uuid: newOrgUid, region: region});
        }
      }
    })
  }

  public getTMPStatus() {
    this.organisationService.trustMarketplaceStatus().subscribe(
      res => {
        this.trustMarketplaceStatusService.setSharedData(res);
        this.trustStatus = res?.status_code;
        if (res?.tmp_admin_status != undefined) {
          this.tmpAdminStatus = res.tmp_admin_status;
        }
        this.trustMarketplaceStatusService.updateTrustStatus(res?.status_code);
        this.trustMarketplaceStatusService.updateTrustAdminStatus(res?.tmp_admin_status);

      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }])
      }
    )
  }

  public openEngageUrl() {
    window.open(this.engageUrl + ConstantsService.ENGAGE_UTM_URL, "_blank");
    return;
  }

  public openTrustMarketPlaceUrl() {
    // Make sure we have the current Trust status
    this.organisationService.trustMarketplaceStatus().subscribe(
      res => {
        this.trustMarketplaceStatusService.setSharedData(res);
        this.trustStatus = res?.status_code;
        if (res?.tmp_admin_status != undefined) {
          this.tmpAdminStatus = res.tmp_admin_status;
        }
        this.trustMarketplaceStatusService.updateTrustStatus(res?.status_code);
        this.trustMarketplaceStatusService.updateTrustAdminStatus(res?.tmp_admin_status);


        const connectedStatusCode = 3;
        let urlToOpen = this.trustStatus === connectedStatusCode ? this.trustUrl + this.languageLocal : this.trustInfoUrl;
        window.open(urlToOpen);

      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }])
      }
    )
  }


  callPlan() {
    this.organisationService.getTurnOver().subscribe((data) => {
      this.turnOver = data.data;
    })
  }

  fetchTurnoverPlanDetails() {
    this.toggleChatbotState(true);
    if (this.billingFlow) {
      return
    }
    if (this.organisationService.dropdownOpen) {
      this.callPlan();
    }
  };

  usageCalculateLog() {
    // Add log when clicked on (How is my usage calculated?)
    this.userdetails = this.permissions.hasxrpUserPermission();
    const metaData = {
      "log": {
        "user_id": this.userdetails['user_id'],
        "email": this.userdetails['email'],
        "name": this.userdetails['name'],
        "username": this.userdetails['username'],
        "message": "User clicked on 'How is my usage calculated?'"
      },
      "audit_log": "CLICK_REQUEST_USAGE_CALCULATE"
    };
    this.planservice.postLog(metaData);
    window.open("https://www.xref.com/how-is-my-usage-calculated?src=xref-platform&ltyp=omni&cn=employer-app", "_blank");
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateBannerFromPlanStatus();
  }

  updateBannerFromPlanStatus() {
    if (this.status.planType === 'future plan') {
      const formattedDate = this.status.validFrom
      this.bannerMessage = this.futureMessage + formattedDate
    } else if (this.status.planType === 'current plan' && this.status.planActive === true && this.status.paymentStatus === 1) {

    } else if (this.status.planType === 'current plan' && this.status.paymentStatus === 2) {
      this.status.showBanner = true;
      this.bannerMessage = this.inactiveMessage
    } else if ((this.status.planType === 'current plan' || this.status.planType === 'no plan') && this.status.planActive === false) {
      this.status.showBanner = true;
      this.showXrefAccountManagerLink = true;
      this.bannerMessage = this.inactiveMessage;
    } else if (this.status.planType === 'past_sign_up_plan') {
      const pastDate = this.status.validTill
      this.status.showBanner = true;
      this.showRenewSubLink = true;
      this.bannerMessage = `${this.pastMessage} ${pastDate}. `
    } else if (this.status.planType === 'past_sales_assisted_plan') {
      const pastDate = this.status.validTill
      this.status.showBanner = true;
      this.showXrefAccountManagerLink = true;
      this.bannerMessage = `${this.pastMessage} ${pastDate}. `
    }
  }

  openTC() {
    window.open('https://www.xref.com/21-terms-conditions?src=xref-platform&ltyp=omni&cn=employer-app', '_blank')
  }

  openPP() {
    window.open('https://www.xref.com/privacy-policy?src=xref-platform&ltyp=omni&cn=employer-app', '_blank')
  }

  openSwitchOrgModal() {
    this.organisationService.listOrganisationForAllRegions().subscribe(
      (res: any) => {
        let initialState = {"availableOrgs": res};
        this.bsModalRef = this.modalService.show(SwitchOrganisationModalComponent, {
          class: 'new-switch-org-modal', initialState
        })

        this.bsModalRef.content.switch.subscribe(res => {
          this.switchOrg(res)
        })
      },
      (err: any) => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  openSwitchOrgBillingFlowModal() {
    this.organisationService.listOrganisationForAllRegions().subscribe(
      (res: any) => {
        let initialState = {"availableOrgs": res, "billingFlow": true};
        this.bsModalRef = this.modalService.show(SwitchOrganisationModalComponent, {
          class: 'new-switch-org-modal', initialState
        })

        this.bsModalRef.content.switch.subscribe(res => {
          this.switchOrg(res)
        })
      },
      (err: any) => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  switchOrg(newOrg: any) {
    const checkResponse = (response: any) => {
      if (!response || response.status == 500) {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      } else {
        localStorage.removeItem('draft_uid');
        Cookies.set(ConstantsService.ORG_COOKIE, newOrg['uuid'], {domain: environment.COOKIE_DOMAIN});
        if (environment.use_global_id) {
          Cookies.set(ConstantsService.API_REGION_TOKEN, newOrg['region'], {domain: environment.COOKIE_DOMAIN});
          if (response['access']) {  // If response has access token, set it
            if (this.ent_9105) {
              Cookies.set(ConstantsService.XREF_ID, response['xref_id'], {domain: environment.COOKIE_DOMAIN});
              sessionStorage.setItem(ConstantsService.AUTH_TOKEN, response['access']);
            } else {
              Cookies.set(ConstantsService.REFRESH_TOKEN, response['refresh'], {domain: environment.COOKIE_DOMAIN});
              Cookies.set(ConstantsService.AUTH_TOKEN, response['access'], {domain: environment.COOKIE_DOMAIN});
            }

            if (response['request_id']) {
              window.location.href = `${environment.TRUST_MARKETPLACE_URL}set-auth-token?ret=${encodeURIComponent(window.location.href)}&token=${response['request_id']}`;
            } else {
              this.windowReload();
            }

          } else if (response.error.data['is_credentialed'] || (this.ent_9105 && response.status == 400)) {  // If response has is_credentialed, logout
            this.auth.logout();  // Login again
          } else {  // SSO redirect
            Cookies.set(ConstantsService.USERNAME, this.permissions.data.username, {domain: environment.COOKIE_DOMAIN});
            this.ssoRedirect(response?.error?.data['sso_url'], response?.error?.data['sso_type']);
          }
        } else {
          Cookies.set(ConstantsService.DEPRECATED_API_REGION_TOKEN, newOrg['region'], {domain: environment.COOKIE_DOMAIN});
          if (response['access']) {  // If response has access token, set it
            if (this.ent_9105) {
              Cookies.set(ConstantsService.XREF_ID, response['xref_id'], {domain: environment.COOKIE_DOMAIN});
              sessionStorage.setItem(ConstantsService.AUTH_TOKEN, response['access']);
            } else {
              Cookies.set(ConstantsService.DEPRECATED_REFRESH_TOKEN, response['refresh'], {domain: environment.COOKIE_DOMAIN});
              Cookies.set(ConstantsService.DEPRECATED_AUTH_TOKEN, response['access'], {domain: environment.COOKIE_DOMAIN});
            }

            if (response['request_id']) {
              window.location.href = `${environment.TRUST_MARKETPLACE_URL}set-auth-token?ret=${encodeURIComponent(window.location.href)}&token=${response['request_id']}`;
            } else {
              this.windowReload();
            }

          } else if (response.error.data['is_credentialed']) {  // If response has is_credentialed, logout
            this.auth.logout();  // Login again
          } else {  // SSO redirect
            Cookies.set(ConstantsService.USERNAME, this.permissions.data.username, {domain: environment.COOKIE_DOMAIN});
            this.ssoRedirect(response.error.data['sso_url'], response.error.data['sso_type']);
          }
        }
      }
    }

    const deprecatedCheckResponse = (response: any) => {
      if (response) {
        if (response.detail === "Error") {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        } else {
          Cookies.set(ConstantsService.ORG_COOKIE, newOrg['uid'], {domain: environment.COOKIE_DOMAIN});
          Cookies.set(ConstantsService.DEPRECATED_API_REGION_TOKEN, newOrg['region'], {domain: environment.COOKIE_DOMAIN});
          localStorage.removeItem('draft_uid');
          if (response['is_credentialed']) {
            this.auth.logout();  // Login again
          } else {
            Cookies.set(ConstantsService.USERNAME, this.permissions.data.username, {domain: environment.COOKIE_DOMAIN});
            this.ssoRedirect(response.sso_url, response.sso_type)
          }
        }
      } else {
        localStorage.removeItem('draft_uid')
        // Reload page
        this.windowReload();
      }
    }
    if (this.ent_9105) {
      this.id.switchOrgs(newOrg['uuid']).subscribe((result: any) => checkResponse(result), (err: any) => checkResponse(err));
    } else {
      this.id.deprecatedSwitchOrgs(newOrg['uuid']).subscribe((result: any) => checkResponse(result), (err: any) => checkResponse(err));
    }
  }

  private ssoRedirect(url: string, type: string) {

    const UUID = uuidv1();
    const nonce = uuidv1();
    const redirectUrl = `${environment.LOGIN_URL}${ConstantsService.SSO_URLS[type]}`;

    // Set cookies required by login for verification
    Cookies.set(ConstantsService.SSO_UUID, UUID, {domain: environment.COOKIE_DOMAIN});
    Cookies.set(ConstantsService.SSO_NONCE, nonce, {domain: environment.COOKIE_DOMAIN});
    Cookies.set(ConstantsService.SSO_REDIRECT_URL, redirectUrl, {domain: environment.COOKIE_DOMAIN});
    Cookies.set(ConstantsService.SSO_PALTFORM, 'omni', {domain: environment.COOKIE_DOMAIN});

    location.assign(`${url}&state=${UUID}&redirect_uri=${redirectUrl}&nonce=${nonce}`);
  }

  contactAccount() {
    this.planservice.getSFDCid().subscribe(
      res => {
        this.mergedContactLink = this.contactLink + res.data.sf_account
        window.open(this.mergedContactLink)
      },
      err => {
        window.open(this.mergedContactLink)
      }
    )

  }

  loginAndOpenRecruiter() {
    if (environment.use_global_id) {
      const payload = {
        audit_log: 'LOGIN_TO_RECRUITER',
        log: {}
      };
      this.organisationService.addAuditLog(payload);
      window.open(environment.RECRUITER_URL, "_blank");
    } else {
      this.organisationService.deprecatedLoginToRecruiter().subscribe(
        (data: any) => {
          let xrp_region = Cookies.get(ConstantsService.DEPRECATED_API_REGION_TOKEN) ? Cookies.get(ConstantsService.DEPRECATED_API_REGION_TOKEN) : 'au';
          if (xrp_region) {
            Cookies.set(ConstantsService.DEPRECATED_RECRUITER_API_REGION_TOKEN, xrp_region, {domain: environment.COOKIE_DOMAIN});
          }
          Cookies.set(ConstantsService.DEPRECATED_RECRUITER_TOKEN, data['token'], {domain: environment.COOKIE_DOMAIN});
          window.open(environment.RECRUITER_URL, "_blank");
        },
        (err: any) => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        });
    }
  }

  private makeRegionalUrl(region: string, url: string): string {
    if (region && region.toLowerCase() !== 'au') {
      this.defaultRegion = region;
      const api = url.slice(0, url.indexOf('.'));
      const domain = url.slice(url.indexOf('.') + 1);

      return `${api}-${region}.${domain}`;
    } else {
      return url;
    }
  }

  private windowReload() {
    window.location.reload();
  }

  logout() {
    this.auth.logoutByUser();
  }

  switchLang(newLang: any) {
    let updatedProfile = {'preferred_language': newLang};
    this.loading = true;
    this.profile.updateProfile(updatedProfile).subscribe(data => {
      this.loading = false;
      if (data['saved']) {
        this.profileData['preferred_language'] = newLang;
        this.redirectToNewLang(this.profileData['preferred_language']);
      } else { // Error case
        this.bsModalRef.content.setMessages(
          [
            {
              'type': 'danger',
              'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            }
          ]
        );
      }
    }, error => {
      this.loading = false;
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  redirectToNewLang(newLang: any) {
    Cookies.set(ConstantsService.XREF_LOCALE, newLang, {domain: environment.COOKIE_DOMAIN});
    window.open(environment.DOMAIN + ConstantsService.LANG_LOCALE_MAP.get(newLang) + this.router.url, "_self");
  }

  // Get Value from kebab Component
  kebabMenuChangeEvent(lang: { key: string, value: string }) {
    this.switchLang(lang?.key)
  }

  setLanguageDropDown() {
    LANG_OPTIONS_WITH_OUT_TRANSLATION?.forEach((value, key) => {
      this.languagesOptionKey.push({key: key, value: value})
    });
  }

  getProfileDetails(): any {
    this.profile.getProfile().subscribe(data => {
      this.loading = false;
      this.profileData = data;
    }, error => {
      this.loading = false;
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  dropdownOpen(isOpen) {
    this.organisationService.setDropdownOpen(isOpen);
  }

  handlePortalClose() {
    this.alertList.append([{
      type: AlertType.SUCCESS,
      message: $localize`If you have made changes to your subscription, these will appear on the platform momentarily.`,
    }]);
  }

  openPortal(): void {
    this.chargebeeInstance.setPortalSession(() => {
      return lastValueFrom(
        this.billingService.createPortalSession(this.selectedOrg.chargebee_customer_id)
      )
        .catch((error: any) => {
          this.alertList.append([{
            type: AlertType.WARNING,
            message: $localize`Billing services are temporarily unavailable. Please try again later.`,
          }]);
          throw error;
        });
    });

    const portal = this.chargebeeInstance.createChargebeePortal();
    portal.open({close: this.handlePortalClose.bind(this)});
  }

  // toggles the state. toFalseOnly will only set the state to false
  toggleChatbotState(toFalseOnly: boolean = false) {
    if (!this.DATA_3300_XREF_AI_CHATBOT) {
      return;
    }

    if (toFalseOnly) {
      this.chatbotState = false;
    } else {
      this.chatbotState = !this.chatbotState;

      // Send auth token when chatbot is opened
      if (this.chatbotState && this.ent_9105_penetration_test_2025) {
        // Update our last known token
        this.lastAuthToken = sessionStorage.getItem(ConstantsService.AUTH_TOKEN);
      }
    }
  }

  // toggles the state. toFalseOnly will only set the state to false
  toggleReportDropdownState(toFalseOnly: boolean = false) {
    if (toFalseOnly) {
      this.reportDropdownState = false;
    } else {
      this.reportDropdownState = !this.reportDropdownState;
    }

    if(this.reportDropdownState){
      this.loadingReportDropdown = true;
      if(this.ENT_10363_PULSE_RELAUNCH){
        this.peopleService.getGeneratedReports().subscribe({
          next: (data) => {
            this.allReports = data.map(item => ({
              id: item.id,
              created: item.created.split('+')[0],
              report_start_datetime: item.report_start_datetime.split('+')[0],
              report_end_datetime: item.report_end_datetime.split('+')[0],
              report_type: item.report_type,
              report_url: item.report_url,
              report_status: item.report_status
            }));
            this.disableGenerateReport = data.length >= ConstantsService.MAX_REPORTS_PER_DAY;
            this.loadingReportDropdown = false;

            if(data.some((item: any) => item.report_status !== 'completed')){
              this.pollGeneratedReportStatus();
            }
          },
          error: (error) => {
            this.loadingReportDropdown = false;
            console.error('Failed to fetch reports:', error);
            this.allReports = [];
          }
        });
      }
      else {
        this.peopleService.getTalentPoolGeneratedReports().subscribe({
          next: (data) => {
            this.allReports = data.map(item => ({
              id: item.id,
              created: item.created.split('+')[0],
              report_start_datetime: item.report_start_datetime.split('+')[0],
              report_end_datetime: item.report_end_datetime.split('+')[0],
              report_type: item.report_type,
              report_url: item.report_url,
              report_status: item.report_status
            }));
            this.disableGenerateReport = data.length >= ConstantsService.MAX_REPORTS_PER_DAY;
            this.loadingReportDropdown = false;

            if(data.some((item: any) => item.report_status !== 'completed')){
              this.pollReportStatus();
            }
          },
          error: (error) => {
            this.loadingReportDropdown = false;
            console.error('Failed to fetch reports:', error);
            this.allReports = [];
          }
        });
      }
    }
  }

  // Detect clicks anywhere in the document
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('#report-menu-button')) {
      // behaviour already handled in click() handler
      return;
    }
    if (!target.closest('.report-menu')) {
      // close dropdown if clicking outside of the report dropdown
      this.toggleReportDropdownState(true);
    }
  }

  showTalentPoolReportModal(){
    this.reportDropdownState = false;

    const componentToShow: any = this.ENT_10363_PULSE_RELAUNCH
      ? GenerateReportComponent
      : TalentPoolReportModalComponent;

    this.bsModalRef = this.modalService.show(componentToShow, {
      class: 'modal-dialog-centered m-popup'
    });

    if (this.ENT_10363_PULSE_RELAUNCH) {
      // Unsubscribe from any existing modal subscription to prevent memory leaks
      if (this.modalCloseEventSubscription) {
        this.modalCloseEventSubscription.unsubscribe();
        this.modalCloseEventSubscription = undefined;
      }

      // Store subscription to unsubscribe later
      if (this.bsModalRef.content?.closeEvent) {
        this.modalCloseEventSubscription = this.bsModalRef.content.closeEvent.subscribe((reason: string | any) => {
          if (reason === 'generate-report-clicked' ) {
            this.toggleReportDropdownState();
          }
        });
      }
    } else {
      // Unsubscribe from any existing modal subscription to prevent memory leaks
      if (this.modalCloseEventSubscription) {
        this.modalCloseEventSubscription.unsubscribe();
        this.modalCloseEventSubscription = undefined;
      }

      // Store subscription to unsubscribe later
      if (this.bsModalRef.content?.closeEvent) {
        this.modalCloseEventSubscription = this.bsModalRef.content.closeEvent.subscribe((reason: string | any) => {
          if (reason === 'generate-report-clicked' ) {
            this.toggleReportDropdownState();
          }
        });
      }
    }
  }

  downloadReport(url: string){
    window.open(url, "_blank");
  }

  getReportTypeLabel(reportType: string): string {
    const reportTypeMap: { [key: string]: string } = {
      'pulse_export': $localize`Pulse report`,
      'talent_pool': $localize`Talent pool`,
    };
    return reportTypeMap[reportType] || $localize`Talent pool`;
  }

  openHelpCenter() {
    window.open(environment.HELP_URL, '_blank');
  }

  /**
   * Open G2 Review modal when user clicks the link
   * Uses cached token if available, otherwise calls G2 endpoint
   */
  openG2ReviewModal(): void {
    // If we have cached token data, use it directly
    if (this.cachedG2TokenData) {
      this.showG2Modal(this.cachedG2TokenData);
      return;
    }

    // Otherwise, fetch the token from the API
    this.g2Service.getG2Token().pipe(
      catchError(error => {
        // Silently fail - don't affect the app if G2 token fails
        console.error('G2 token request failed:', error);
        return of(null);
      })
    ).subscribe(response => {
      if (response && response['data']) {
        // Cache the token data in memory
        this.cachedG2TokenData = {
          state: response['data']['state'] || '',
          review_exists: response['data']['review_exists'] || false
        };

        // Show the modal with the cached data (will show appropriate message if review exists)
        this.showG2Modal(this.cachedG2TokenData);
      }
    });
  }

  /**
   * Show the G2 modal with the provided token data
   */
  private showG2Modal(tokenData: { state: string; review_exists: boolean }): void {
    // If review already exists, show the "already reviewed" message
    if (tokenData.review_exists === true) {
      setTimeout(() => {
        const initialState = {
          reviewAlreadyExists: true,
          g2FormsUrl: null
        };
        this.bsModalRef = this.modalService.show(G2FormsModalComponent, {
          class: 'modal-dialog-centered g2-modal-600',
          initialState,
          animated: true
        });
      }, 100);
      return;
    }

    const userEmail = this.permissions.data?.email;

    if (userEmail && tokenData.state && tokenData.state !== '') {
      // Construct G2 iframe URL with state and email
      const urlString = `${environment.G2_FORMS_BASE_URL}?state=${tokenData.state}&email=${encodeURIComponent(userEmail)}`;
      // Sanitize the URL for Angular security
      const g2FormsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlString);

      // Show the modal
      setTimeout(() => {
        const initialState = {
          g2FormsUrl: g2FormsUrl,
          reviewAlreadyExists: false
        };
        this.bsModalRef = this.modalService.show(G2FormsModalComponent, {
          class: 'modal-dialog-centered g2-modal-600',
          initialState,
          animated: true
        });
      }, 100);
    }
  }

  retryReport(report){
    this.loadingReportDropdown = true;
    const payload = { report_id: report.id };
    this.peopleService.retryTalentPoolReport(payload).subscribe({
      next: (_res) => {
        this.pollReportStatus();
        this.loadingReportDropdown = false;
      },
      error: (err) => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    });
  }

  pollReportStatus() {
    const endpoint = 'people/organisation/talent-pool/report/generated-reports';

    const stopPolling$ = timer(this.stopPollingTime); // Emits after 180 secs

    this.pollingSubscription = interval(this.timeInterval)
      .pipe(
        takeUntil(stopPolling$),
        switchMap(() => this.apiService.get(endpoint).pipe(map(res => res['data']))),
        takeWhile((res: any[]) => res.some(item => item.report_status !== 'completed'), true)
      )
      .subscribe({
        next: (data) => {
          data.forEach((item, index) => {
            if(item.report_status === 'completed'){
              this.allReports[index].created = item.created.split('+')[0];
              this.allReports[index].report_start_datetime = item.report_start_datetime.split('+')[0];
              this.allReports[index].report_end_datetime = item.report_end_datetime.split('+')[0];
              this.allReports[index].report_type = item.report_type;
              this.allReports[index].report_url = item.report_url;
              this.allReports[index].report_status = item.report_status;
            }
          });
        },
        error: (err) => {
          console.error('Polling failed', err);
          this.allReports = [];
        }
      });
  }

  pollGeneratedReportStatus() {

    const endpoint = 'report/generated-reports';

    const stopPolling$ = timer(this.stopPollingTime); // Emits after 180 secs

    this.pollingSubscription = interval(this.timeInterval)
      .pipe(
        takeUntil(stopPolling$),
        switchMap(() => this.apiService.get(endpoint).pipe(map(res => res['data']))),
        takeWhile((res: any[]) => res.some(item => item.report_status !== 'completed'), true)
      )
      .subscribe({
        next: (data) => {
          data.forEach((item, index) => {
            if(item.report_status === 'completed'){
              this.allReports[index].created = item.created.split('+')[0];
              this.allReports[index].report_start_datetime = item.report_start_datetime.split('+')[0];
              this.allReports[index].report_end_datetime = item.report_end_datetime.split('+')[0];
              this.allReports[index].report_type = item.report_type;
              this.allReports[index].report_url = item.report_url;
              this.allReports[index].report_status = item.report_status;
            }
          });
        },
        error: (err) => {
          console.error('Polling failed', err);
          this.allReports = [];
        }
      });
  }


  private setupAuthTokenMonitoring() {
    // Store initial token
    this.lastAuthToken = sessionStorage.getItem(ConstantsService.AUTH_TOKEN);

    // Store references to event listeners for proper cleanup
    this.onStorageListener = (event: StorageEvent) => {
      if (event.key === ConstantsService.AUTH_TOKEN && this.chatbotState) {
        this.handleTokenChange();
      }
    };

    this.onMessageListener = (event: MessageEvent) => {
      this.handleIframeMessage(event);
    };

    // Listen for storage changes (catches token updates/refresh)
    window.addEventListener('storage', this.onStorageListener);

    // Listen for messages from the iframe
    window.addEventListener('message', this.onMessageListener);
  }

  private handleIframeMessage(event: MessageEvent) {

    // Only process messages from the chatbot iframe
    if (!this.DATA_3300_XREF_AI_CHATBOT || !this.chatbotState) {
      return;
    }

    // Feature flag gating
    if (!this.ent_9105_penetration_test_2025) {
      return;
    }

    // Validate origin strictly
    const region = (this.regionService.getRegion() ?? 'au').toLowerCase();
    let expectedOrigin: string | null = null;
    try {
      expectedOrigin = new URL(environment.XREF_CHAT_URL[region]).origin;
    } catch (_e) {
      expectedOrigin = null;
    }
    if (!expectedOrigin || event.origin !== expectedOrigin) {
      // Unexpected origin; ignore
      return;
    }

    // Check if the message is the 'ready' status we're waiting for
    if (event.data && event.data.type === 'status' && event.data.value === 'ready') {
      console.log('Chatbot iframe is ready, sending auth token');
      // Send the auth token immediately when iframe is ready
      this.sendAuthTokenToIframe();
    }
  }

  private handleTokenChange() {
    const currentToken = sessionStorage.getItem(ConstantsService.AUTH_TOKEN);
    if (currentToken !== this.lastAuthToken) {
      console.log('Auth token changed, sending new token to chatbot');
      this.lastAuthToken = currentToken;
      this.sendAuthTokenToIframe();
    }
  }

  private sendAuthTokenToIframe() {
    if (!this.DATA_3300_XREF_AI_CHATBOT || !this.chatbotState) {
      return;
    }

    // Feature flag gating
    if (!this.ent_9105_penetration_test_2025) {
      return;
    }

    // Get the current region and chatbot URL
    const region = this.regionService.getRegion() ?? 'au';
    const chatbotUrl = environment.XREF_CHAT_URL[region];

    if (!chatbotUrl) {
      console.warn('Chatbot URL not found for region:', region);
      return;
    }

    // Extract domain from chatbot URL for secure targetOrigin
    let targetOrigin: string;
    try {
      const url = new URL(chatbotUrl);
      targetOrigin = url.origin; // This will be 'https://xrefy.xref.com' etc.
    } catch (error) {
      console.warn('Invalid chatbot URL:', chatbotUrl);
      return;
    }

          // Get auth token from sessionStorage (new ID flow only)
      const authToken = sessionStorage.getItem(ConstantsService.AUTH_TOKEN);

      if (!authToken) {
        console.warn('No auth token available in sessionStorage');
        return;
      }

    // Find the chatbot iframe
    const iframe = document.querySelector('.app-xref-chatbot-container iframe') as HTMLIFrameElement;
    if (!iframe || !iframe.contentWindow) {
      console.warn('Chatbot iframe not found');
      return;
    }

    // Send token with restricted targetOrigin for security
    const message = {
      type: 'auth-token',
      token: authToken,
      region: region,
      timestamp: Date.now()
    };

    try {
      iframe.contentWindow.postMessage(message, targetOrigin);
      console.log('Auth token sent to chatbot iframe with targetOrigin:', targetOrigin);
    } catch (error) {
      console.error('Failed to send auth token to chatbot:', error);
    }
  }

  ngOnDestroy(): void {
    this.pollingSubscription?.unsubscribe();
    if (this.aiSettingsSubscription) {
      this.aiSettingsSubscription.unsubscribe();
    }

    if (this.modalCloseEventSubscription) {
      this.modalCloseEventSubscription.unsubscribe();
    }

    // Remove event listeners using the same references used for addEventListener
    window.removeEventListener('storage', this.onStorageListener);
    window.removeEventListener('message', this.onMessageListener);
  }
}
